// extracted by mini-css-extract-plugin
export var root = "Header-module--root--N-IUI";
export var titleBlock = "Header-module--titleBlock--p5-mD";